import { useRef, useState } from "react";
import { TpvDialog } from "../../../components/TpvDialog";
import { formatMoney } from "../../../utils/pricing";

export const OrderReview = ({ lines, total, onConfirm, onClose, homeDelivery = false }) => {
  const pending = useRef(false);
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const confirm = async () => {
    if (pending.current) return;
    pending.current = true;
    setBusy(true);
    setError("");
    try { await onConfirm(); }
    catch (e) { setError(e.message || "No se pudo confirmar el pedido. Revisa su estado antes de repetir."); }
    finally { pending.current = false; setBusy(false); }
  };
  return <TpvDialog title="Resumen del pedido" onClose={onClose} busy={busy} className="tpvOrderReview">
    <div className="tpvOrderReviewBody">
      <p>Revisa el pedido antes de enviarlo a Cocina.</p>
      <ul>{lines.map((line, index) => <li key={line.id || line.shoppingCartProductId || index}>
        <strong>{line.quantity} × {line.Product?.shortName || line.Product?.name || line.name || "Producto"}</strong>
        {line.info && <span className="shoppingProductMeta">{line.info}</span>}
      </li>)}</ul>
      <div className="tpvOrderReviewTotal"><span>Total</span><strong>{formatMoney(total)}</strong></div>
      <p>{homeDelivery ? "Confirmar envía el pedido a Cocina y termina la venta. El repartidor cobrará al entregar." : "Confirmar envía el pedido a Cocina y permite cobrarlo más tarde desde el TPV."}</p>
      {error && <p role="alert">{error}</p>}
    </div>
    <div className="tpvOrderReviewActions">
      <button type="button" disabled={busy} onClick={confirm}>Confirmar</button>
    </div>
  </TpvDialog>;
};
